import styled from 'styled-components'

export default styled.div`
  &.read-only {
    opacity: 0.5;
  }
`

export const FieldGroup = styled.div`
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: ${(props) =>
        props.width ? `${props.width}px` : 'auto'} 1fr;
  }

  label {
    font-size: 1.4rem;
    color: black;
    margin-right: 2rem;
    margin-top: 1rem;
    width: ${(props) => (props.width ? `${props.width}px` : 'auto')};

    &.error {
      color: ${(props) => props.theme.palette.error};
    }
  }
`

export const InputContainer = styled.div`
  border: 1px solid ${(props) => props.theme.palette.gray[100]};
  background-color: white;
  border-radius: 0.6rem;
  height: 4rem;
  font-size: 1.4rem;
  outline: none;
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;

  &.disabled {
    background-color: #f2f2f2;
  }

  &:hover,
  &:active,
  &:focus {
    border: 1px solid ${(props) => props.theme.palette.gray[200]};
  }

  &.error {
    border-color: ${(props) => props.theme.palette.error};
  }

  input {
    border: none;
    background-color: transparent;
    padding: 1rem;
    font-size: 1.4rem;
    height: 100%;
    outline: none;
    width: 100%;
  }

  .prefix {
    padding: 1rem;
    background-color: #eee;
    border-top-left-radius: 0.6rem;
    border-bottom-left-radius: 0.6rem;
  }

  .suffix {
    padding: 1rem;
    background-color: #eee;
    border-top-right-radius: 0.6rem;
    border-bottom-right-radius: 0.6rem;
  }

  .clear-icon {
    background-color: transparent;
    border: none;
    outline: none;
    height: 2rem;
    padding: 0 0.5rem;
  }
`

export const Error = styled.div`
  color: ${(props) => props.theme.palette.error};
  font-size: 1.1rem;
  width: 100%;
  display: block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`
